import {
  Component,
  OnInit,
  Inject,
  ViewEncapsulation,
} from "@angular/core";

import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import "jspdf-autotable";
import { RollbarService } from "../../../rollbar";
import * as Rollbar from "rollbar";
import { SessionCheck, generateAlertMessage } from "../../../app-general";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { distinctUntilChanged, tap } from 'rxjs/operators';
declare const require: any;
const jsPDF = require("jspdf");
require("jspdf-autotable");

@Component({
  selector: "app-downnload-asset",
  templateUrl: "./downnload-asset.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrls: ["./downnload-asset.component.scss"],
})
export class DownnloadAssetComponent implements OnInit {
  public watcher: Observable<boolean>;
  columns = 2;
  CurrentTime: any;
  assetitem;

  public isExcelDownload = false;
  public isPDFDownload = false;
  Breakpoints = Breakpoints;
  readonly breakpoint$ = this.breakpointObserver
    .observe([Breakpoints.Large, Breakpoints.Medium, Breakpoints.Small, '(min-width: 500px)'])
    .pipe(
      tap(value => console.log(value)),
      distinctUntilChanged()
    );
    
  constructor(
    private router: Router,    
    public thisDialogRef: MatDialogRef<DownnloadAssetComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(RollbarService) private rollbar: Rollbar,
    private breakpointObserver: BreakpointObserver
  ) {
      this.breakpoint$.subscribe(() => this.breakpointChanged());    
  }
  
  breakpointChanged() {    
    if(this.breakpointObserver.isMatched(Breakpoints.Large) || this.breakpointObserver.isMatched(Breakpoints.Medium) ||
    this.breakpointObserver.isMatched(Breakpoints.Small)) {
      this.columns = 2;
    }         
    else if(this.breakpointObserver.isMatched(Breakpoints.XSmall)) {
      this.columns = 1;
    }
  }
  
  ngOnInit() {
    const loaderelement = document.getElementsByClassName("loadassetspinner");
    loaderelement[0]["style"].display = "none";
  }

  public onCloseCancel = () => {
    this.thisDialogRef.close("Cancel");
    if (!SessionCheck(this.router)) {
      return;
    }
  };

  downloaassetcsv(resdata) {
    const loaderelement = document.getElementsByClassName("loadassetspinner");
    loaderelement[0]["style"].display = "block";
    setTimeout(() => {
      this.downloadasset_csv(resdata);
    }, 3);
  }

  downloadasset_csv(assetData) {
    try {
      if (!SessionCheck(this.router)) {
        this.thisDialogRef.close("Cancel");
        return;
      }
      if (!this.isExcelDownload) {
        this.isExcelDownload = true;
        const downloadasset = {
          Data: [] as any[],
        };

        for (let i = 0; i < assetData.length; i++) {
          this.assetitem = assetData[i];

          downloadasset.Data.push({
            "Tag Id": this.assetitem.TagId,
            "Asset Name": this.assetitem.AssetName,
            "Asset Name Alias": this.assetitem.AssetNameAlias,
            "Asset Type": this.assetitem.AssetType,
          });
        }

        this.JSONToCSVConvertor(downloadasset.Data, "", true);
      }
    } catch (err) {
      throw new Error(
        "download-asset.component.ts" +
          " - downloadassetExcel() - " +
          err.message
      );
    }
  }
  JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
    // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    try {
      const arrData =
        typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;

      let CSV = "";

      if (ShowLabel) {
        let row = "";

        for (const index in arrData[0]) {
          row += index + ",";
        }

        row = row.slice(0, -1);
        CSV += row + "\r\n";
      }

      if (arrData.length > 0) {
        for (let i = 0; i < arrData.length; i++) {
          let row = "";
          for (const index in arrData[i]) {
            row += '"' + arrData[i][index] + '",';
          }
          row.slice(0, row.length - 1);
          CSV += row + "\r\n";
        }
        if (CSV == "") {
          const loaderelement =
            document.getElementsByClassName("loadassetspinner");
          loaderelement[0]["style"].display = "none";
          generateAlertMessage(this.dialog, "Invalid data");
          this.isExcelDownload = false;
          return;
        }
        let fileName = "AssetReport";
        fileName += ReportTitle.replace(/ /g, "_");

        const myBlob = new Blob([CSV], { type: "text/html" });
        const url = window.URL.createObjectURL(myBlob);
        const a = document.createElement("a");
        const link = document.body.appendChild(a);
        document.body.appendChild(link);
        link.href = url;
        this.CurrentTime =
          new Date().getFullYear() +
          ("0" + (new Date().getMonth() + 1)).slice(-2) +
          ("0" + new Date().getDate()).slice(-2) +
          "_" +
          new Date().getHours() +
          "_" +
          new Date().getMinutes() +
          "_" +
          new Date().getSeconds();
        link.download = fileName + "_" + this.CurrentTime + ".csv";
        link.click();
      } else {
        const loaderelement = document.getElementsByClassName("loadassetspinner");
        loaderelement[0]["style"].display = "none";
        generateAlertMessage(this.dialog, "No data available");
        this.isExcelDownload = false;
      }
      const loaderelement = document.getElementsByClassName("loadassetspinner");
      loaderelement[0]["style"].display = "none";
      this.isExcelDownload = false;
    } catch (err) {
      throw new Error(
        "download-asset.component.ts" +
          " - JSONToCSVConvertor() - " +
          err.message
      );
    }
  }

  downloaassetpdf(resdata) {
    const loaderelement = document.getElementsByClassName("loadassetspinner");
    loaderelement[0]["style"].display = "block";
    setTimeout(() => {
      this.downloadasset_pdf(resdata);
    }, 3);
  }

  downloadasset_pdf(assetData) {
    try {
      if (!SessionCheck(this.router)) {
        this.thisDialogRef.close("Cancel");
        return;
      }
      if (!this.isPDFDownload) {
        this.isPDFDownload = true;
        const assetdownloadData = [] as any[];
        this.CurrentTime =
          new Date().getFullYear() +
          ("0" + (new Date().getMonth() + 1)).slice(-2) +
          ("0" + new Date().getDate()).slice(-2) +
          "_" +
          new Date().getHours() +
          "_" +
          new Date().getMinutes() +
          "_" +
          new Date().getSeconds();
        const columns = [
          { title: "Tag Id", dataKey: "TagId" },
          { title: "Asset Name", dataKey: "AssetName" },
          { title: "Asset Name Alias", dataKey: "AssetNameAlias" },
          { title: "Asset Type", dataKey: "AssetType" },
        ];

        if (assetData.length > 0) {
          for (let i = 0; i < assetData.length; i++) {
            const TagId = assetData[i].TagId;
            const AssetName = assetData[i].AssetName;
            const AssetNameAlias = assetData[i].AssetNameAlias;
            const AssetType = assetData[i].AssetType;

            assetdownloadData.push({
              TagId,
              AssetName,
              AssetNameAlias,
              AssetType,
            });
          }

          const pdf = new jsPDF("l"); // A4 size page of PDF
          let PdfFileName = "AssetReport";
          const pageWidth =
            pdf.internal.pageSize.width || pdf.internal.pageSize.getWidth();
          pdf.text("Asset Report", pageWidth / 2, 10, "center");
          const options = {
            theme: "grid",
            bodyStyles: { lineColor: [0, 0, 0] },
            tableWidth: 'auto',
            columnWidth: 'wrap',
            showHeader: 'everyPage',
            headStyles: {
              lineWidth: 0.2,
              lineColor: [0, 0, 0],
              textColor: [0, 0, 0],
              fillColor: [169, 169, 169],
            },
            rowPageBreak: "avoid",
          };
          pdf.autoTable(columns, assetdownloadData, options);
          PdfFileName = PdfFileName + "_" + this.CurrentTime + ".pdf";
          pdf.save(PdfFileName);
          const loaderelement =
            document.getElementsByClassName("loadassetspinner");
          loaderelement[0]["style"].display = "none";
          this.isPDFDownload = false;
        } else {
          const loaderelement =
            document.getElementsByClassName("loadassetspinner");
          loaderelement[0]["style"].display = "none";
          generateAlertMessage(this.dialog, "No data available");
          this.isPDFDownload = false;
        }
        const loaderelement = document.getElementsByClassName("loadassetspinner");
        loaderelement[0]["style"].display = "none";
        this.isPDFDownload = false;
      }
    } catch (err) {
      throw new Error(
        "download-asset.component.ts" + " - downloadassetPdf() - " + err.message
      );
    }
  }
}
